import CustomerTrash from "./components/CustomerTrash";

export default CustomerTrash;
